<template>
  <van-popup v-model="showBind" class="backRect" @closed="onClosed">
    <TopBar :pagetitle="title" :is-left-self="true" @leftClick="onBack" />
    <van-field
      v-model="model.emailAddress"
      required
      readonly=""
      label="电子邮箱"
    />
    <van-field
      v-model="password"
      required
      clearable
      type="password"
      maxlength="32"
      label="密码"
      placeholder="请输入AIDA系统的密码"
    />

    <div class="buttonRect">
      <van-button type="primary" size="large" :loading="buttonLoading" :color="GetColorMain()" @click="onSetPassword">设置登录密码</van-button>
    </div>
    <div class="regAbout">
      输入您的AIDA系统密码，我们将会协助您确认课程,以便快速完成证书签发的工作。
    </div>
  </van-popup>

</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { Button, Popup, Field, Toast } from 'vant'
import { MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    TopBar
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
  },
  data() {
    return {
      title: '设置AIDA密码',
      showBind: false,
      buttonLoading: false,
      model: {

      },
      password: ''
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.password = ''
        this.model = newValue
        this.showBind = true
      } else {
        this.showBind = false
      }
    }
  },
  created() {

  },
  methods: {
    MyNotify,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    init() {

    },
    onClosed() {
      this.$emit('input', false)
    },
    onBack() {
      this.showBind = false
      return true
    },
    onSetPassword() {
      if (!this.password || this.password.length < 6) {
        MyNotify('info', '请输入至少6位密码')
        return
      }
      this.buttonLoading = true
      request({
        url: '/user/setAidaAccount',
        method: 'post',
        data: {
          studentAidaId: this.model.studentAidaId,
          password: this.password
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        Toast.success('设置密码成功')
        this.showBind = false
        this.$emit('reload')
      })
    }

  }
}
</script>
<style scoped>
.backRect{
    width: 100vw;
    height: 100vh;
    background-color: #F1f1f1;
}
.inputRect{
  margin: 1em 1em 0 1em;
  background-color: #fff;
  border-radius: 0.5em;
  overflow: hidden;
}
.regAbout{
  margin:1em 2em;
  color: #999;
  font-size: 0.8em;
}
</style>
